/* eslint-disable @department-of-veterans-affairs/prefer-button-component */
/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import recordEvent from '~/platform/monitoring/record-event';

// The gov banner and crisis line as content-build's page shell renders them
// (styled by the site-wide stylesheet), matching the design system's
// WithContentPage story. The ids differ from the shell's, whose copy stays in
// the hidden legacy header.
export const BannerRows = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="va-notice--banner">
      <div className="va-notice--banner-inner">
        <div className="usa-banner">
          <div className="usa-accordion">
            <div
              className={`usa-banner-header${
                expanded ? ' usa-banner-header-expanded' : ''
              }`}
            >
              <div className="usa-grid usa-banner-inner">
                <img alt="" aria-hidden="true" src="/img/tiny-usa-flag.png" />
                <p>An official website of the United States government</p>
                <button
                  className="usa-accordion-button usa-banner-button"
                  aria-expanded={expanded}
                  aria-controls="header-gov-banner"
                  onClick={() => setExpanded(!expanded)}
                >
                  <span className="usa-banner-button-text">
                    Here’s how you know
                  </span>
                </button>
              </div>
            </div>
            <div
              className="usa-banner-content usa-grid usa-accordion-content"
              id="header-gov-banner"
              aria-hidden={!expanded}
            >
              <div className="usa-banner-guidance-gov usa-width-one-half">
                <img
                  alt="Dot gov"
                  className="usa-banner-icon usa-media_block-img"
                  src="/img/icon-dot-gov.svg"
                />
                <div className="usa-media_block-body">
                  <p>
                    <strong>The .gov means it’s official.</strong>
                    <br />
                    Federal government websites often end in .gov or .mil.
                    Before sharing sensitive information, make sure you’re on a
                    federal government site.
                  </p>
                </div>
              </div>
              <div className="usa-banner-guidance-ssl usa-width-one-half">
                <img
                  alt="SSL"
                  className="usa-banner-icon usa-media_block-img"
                  src="/img/icon-https.svg"
                />
                <div className="usa-media_block-body">
                  <p>
                    <strong>The site is secure.</strong>
                    <br /> The <strong>https://</strong> ensures that you’re
                    connecting to the official website and that any information
                    you provide is encrypted and sent securely.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="va-crisis-line-container vads-u-background-color--secondary-darkest">
        <button
          className="va-crisis-line va-overlay-trigger vads-u-background-color--secondary-darkest"
          data-show="#modal-crisisline"
          onClick={() => {
            recordEvent({ event: 'nav-crisis-header' });
            recordEvent({ event: 'nav-jumplink-click' });
          }}
        >
          <div className="va-crisis-line-inner">
            <span className="va-crisis-line-icon" aria-hidden="true" />
            <span className="va-crisis-line-text">
              Talk to the <strong>Veterans Crisis Line</strong> now
            </span>
            <img
              alt=""
              aria-hidden="true"
              className="va-crisis-line-arrow"
              src="/img/arrow-right-white.svg"
            />
          </div>
        </button>
      </div>
    </div>
  );
};

export default BannerRows;
